export const FROM_MULTI_CTA_KEY = 'fromMultiCta';
